import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'

const ImageViewModal = ({ imageUrl }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <div className="cursor-pointer" onClick={handleShow}>
                <img src={imageUrl} alt='news' className='h-28 rounded-md object-cover bg-slate-500 mx-auto' />
            </div>
            <Modal show={show} onHide={handleClose} size='xl' className='mx-auto !flex justify-center w-full'>
                <Modal.Body className='bg-[var(--gray-background)] rounded-xl'>
                    <div className="flex justify-between items-center h-[90vh]">
                        <img src={imageUrl} alt="" className=' max-h-[100%] object-cover mx-auto' />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ImageViewModal